import CONFIG_COMPANY from "./myConfig";

let COMPANIES = {
    CFNS: {
        NAME: "cfns",
        HOME: "/home-page",
        WOD: null,
        // WOD: {
        //     id: "zoNrXL8ABB",
        //     color: "#93C83F",
        //     label: "WOD",
        //     position: "bottom-left",
        // },
        TITLE: "Crossfit NS",
        LOGIN_LOGO: '/cfns/cfns_logo.png',
        DEFAULT_TRAINING_TYPES: ['Skill','Outdoor', 'Mobility', 'Grupni', 'WL', 'Lift Lab', 'Heart Jump' , 'BodyForge'],
        SHOW_TRAINING_TYPE_REPORT: false,
        ADD_SLOT_PERMISSION: false,
        SHOW_TOTAL_PRICE_REPORT: true,
        SORT_TRAININGS_BY_TIME: null,
        SHOW_PAYMENT_MONEY_IN_PAYMENT_REPORT: true,
        SHOW_TOTAL_TERMINS: false,
        SHOW_INFINITY_TRAININGS: true,
        SHOW_USER_TRAINING_TYPE_ON_TRAINING: false,
        ADD_KEY_FOR_TRAINING: false,
        SHOW_ADD_TRAINER_ON_SLOT: false,
        SHOW_PACKAGE_MEMBERSHIP: true,
        LISTEN_FIREBASE_QR_SCAN: false,
        CUSTOM_LOCALIZATION: {
            EN: {
                "label_max_people_on_training": 'Max treninga',
                "label_name_for_partner": 'partner',
                "t_see_all": '',
            },
            SR: {
                "label_max_people_on_training": 'Max treninga',
                "label_name_for_partner": 'saradnik',
                "t_see_all": '',
            }
        },
        TABS: "HOME,BAR_POS,ORDERS,INVENTORY,TRAININGS,BAR_SALDO_REPORT,PROFIT,USR_REPORT,WAREHOUSE,REPORT_TR,SHOP,TRN_TYPES,WOD,USERS,SCHEDULE,PAYMENTS,PARTNERS,MEMBERSHIPS,INVOICES,COMPANIES",
        RIGHT_TABS: "NUMBER_OF_TRAININGS,MY_MEMBER,ACCOUNT",
        IS_ENABLED_BOTTOM_BAR: true,
        HIDDEN_COLUMNS_USER_TABLE:"SHOES_SIZE",
        ENABLE_GENDER: true,
        SHOW_WOD_RESULTS: true,
        SPECIFIC_ROLES: {
            testcfnspremium : {
                TABS: "HOME,ADD_NOTIFICATION",
                RIGHT_TABS: "",
                ENABLE_ADD_NOTIFICATION: true
            },
            OMilosevic : {
                TABS: "HOME,ADD_NOTIFICATION",
                RIGHT_TABS: "",
                ENABLE_ADD_NOTIFICATION: true
            },
            ProbniTr : {
                ENABLE_ADD_STOCK_PRODUCT: true
            }
        },
        BAR_POS_DISCOUNTS: [0, 10, 30, 100],
    },

    FISKULTURA: {
        NAME: "fiskultura",
        HOME: "/home-page",
        WOD: null,
        TITLE: "Fiskultura",
        LOGIN_LOGO: '/fiskultura/fiskultura_logo1.jpeg',
        DEFAULT_TRAINING_TYPES: [],
        SHOW_TRAINING_TYPE_REPORT: true,
        ADD_SLOT_PERMISSION: true,
        SHOW_TOTAL_PRICE_REPORT: true,
        SORT_TRAININGS_BY_TIME: "ASC",
        SHOW_PAYMENT_MONEY_IN_PAYMENT_REPORT: true,
        SHOW_TOTAL_TERMINS: true,
        SHOW_INFINITY_TRAININGS: false,
        SHOW_USER_TRAINING_TYPE_ON_TRAINING: false,
        ADD_KEY_FOR_TRAINING: false,
        SHOW_ADD_TRAINER_ON_SLOT: false,
        SHOW_PACKAGE_MEMBERSHIP: false,
        LISTEN_FIREBASE_QR_SCAN: false,
        CUSTOM_LOCALIZATION: {
            EN: {
                "label_max_people_on_training": 'Number people on training',
                "label_name_for_partner": 'trainer',
                "label_ci_nutrition": "About us",
                "label_ci_nutrition_add": "Add new item",
                "label_ci_nutrition_name": "Item name",
                "label_ci_nutrition_name_en": "Item name (en)",
            },
            SR: {
                "label_max_people_on_training": 'Broj ljudi na treningu',
                "label_name_for_partner": 'trener',
                "label_ci_nutrition": "O nama",
                "label_ci_nutrition_add": "Dodaj novu stavku",
                "label_ci_nutrition_name": "Ime stavke",
                "label_ci_nutrition_name_en": "Ime stavke (en)",
            }
        },
        TABS: "HOME,TRAININGS,REPORT_TR,TRN_TYPES,USR_REPORT,USERS,RPRT_TRAINER,SCHEDULE,PERSONAL,PAYMENTS,PARTNERS,COMPANY_PARTNERS,MEMBERSHIPS,INVOICES,COMPANIES",
        RIGHT_TABS: "NUMBER_OF_TRAININGS,MY_MEMBER,ACCOUNT",
        IS_ENABLED_BOTTOM_BAR: true,
        HIDDEN_COLUMNS_USER_TABLE:"SHOES_SIZE,BAR_BALANCE",
        USER_TYPES: [
            {
                id: "USER_TYPE_ONLINE",
                label: 'label_user_type_online'
            },
            {
                id: "USER_TYPE_TRAINING_CENTER",
                label: 'label_user_type_training_center'
            },
            {
                id: "USER_TYPE_BOTH",
                label: 'label_user_type_both'
            },
        ]
    },

    PODBARAGYM: {
        NAME: "podbaragym",
        HOME: "/home-page",
        WOD: null,
        TITLE: "Podbara Gym",
        LOGIN_LOGO: '/podbaragym/podbaragym_logo.png',
        DEFAULT_TRAINING_TYPES: ["Teretana"],
        SHOW_TRAINING_TYPE_REPORT: true,
        ADD_SLOT_PERMISSION: true,
        SHOW_TOTAL_PRICE_REPORT: true,
        SORT_TRAININGS_BY_TIME: "DESC",
        SHOW_PAYMENT_MONEY_IN_PAYMENT_REPORT: true,
        SHOW_TOTAL_TERMINS: true,
        SHOW_INFINITY_TRAININGS: false,
        SHOW_USER_TRAINING_TYPE_ON_TRAINING: false,
        ADD_KEY_FOR_TRAINING: false,
        SHOW_ADD_TRAINER_ON_SLOT: false,
        SHOW_PACKAGE_MEMBERSHIP: false,
        LISTEN_FIREBASE_QR_SCAN: false,
        CUSTOM_LOCALIZATION: {
            EN: {
                "label_max_people_on_training": 'Number people on training',
                "label_name_for_partner": 'trainer'
            },
            SR: {
                "label_max_people_on_training": 'Broj ljudi na treningu',
                "label_name_for_partner": 'trener'
            }
        },
        TABS: "HOME,ENTRANCE,ENTRA_TRAINER,TRAININGS,USR_REPORT,REPORT_TR,TRN_TYPES,USERS,SCHEDULE,PAYMENTS,PARTNERS,MEMBERSHIPS,INVOICES,COMPANIES",
        RIGHT_TABS: "NUMBER_OF_TRAININGS,MY_MEMBER,ACCOUNT",
        IS_ENABLED_BOTTOM_BAR: true,
        HIDDEN_COLUMNS_USER_TABLE:"SHOES_SIZE,BAR_BALANCE",
        USE_QR_SCANNER_FOCUS: true,
        ENABLE_REMOTE_OPEN_DOOR: true,
    },

    LIBERO_FITNESS_TEAM: {
        NAME: "libero",
        HOME: "/home-page",
        WOD: null,
        TITLE: "Libero Fitness Team",
        LOGIN_LOGO: '/libero/libero_logo.png',
        DEFAULT_TRAINING_TYPES: [],
        SHOW_TRAINING_TYPE_REPORT: true,
        ADD_SLOT_PERMISSION: true,
        SHOW_TOTAL_PRICE_REPORT: true,
        SORT_TRAININGS_BY_TIME: "ASC",
        SHOW_PAYMENT_MONEY_IN_PAYMENT_REPORT: true,
        SHOW_TOTAL_TERMINS: true,
        SHOW_INFINITY_TRAININGS: false,
        SHOW_USER_TRAINING_TYPE_ON_TRAINING: false,
        ADD_KEY_FOR_TRAINING: false,
        SHOW_ADD_TRAINER_ON_SLOT: true,
        SHOW_PACKAGE_MEMBERSHIP: false,
        LISTEN_FIREBASE_QR_SCAN: false,

        CUSTOM_LOCALIZATION: {
            EN: {
                "label_max_people_on_training": 'Number people on training',
                "label_name_for_partner": 'trainer',
                "label_currency": '€',
                "label_lesson_url": 'Trainings link'
            },
            SR: {
                "label_max_people_on_training": 'Broj ljudi na treningu',
                "label_name_for_partner": 'trener',
                "label_currency": '€',
                "label_lesson_url": 'Link do treninga'
            }
        },
        TABS: "HOME,TRAININGS,REPORT_TR,SHOP,WOD,PROFIT,USR_REPORT,ORDERS,TRN_TYPES,USERS,PERSONAL,SCHEDULE,PAYMENTS,PARTNERS,COMPANY_PARTNERS,MEMBERSHIPS,INVOICES,COMPANIES",
        RIGHT_TABS: "NUMBER_OF_TRAININGS,MY_MEMBER,ACCOUNT",
        IS_ENABLED_BOTTOM_BAR: true,
        HIDDEN_COLUMNS_USER_TABLE:"SHOES_SIZE,BAR_BALANCE",
        USER_TYPES: [
            {
                id: "USER_TYPE_ONLINE",
                label: 'label_user_type_online'
            },
            {
                id: "USER_TYPE_TRAINING_CENTER",
                label: 'label_user_type_training_center'
            },
            {
                id: "USER_TYPE_BOTH",
                label: 'label_user_type_both'
            },
        ],
        SHOW_USER_ADDITIONAL_INFO_LESSON_URL: true,
    },

    JUMPANDPUMP: {
        NAME: "jump",
        HOME: "/home-page",
        WOD: null,
        TITLE: "Jump&Pump",
        LOGIN_LOGO: '/jump/jump_logo.png',
        DEFAULT_TRAINING_TYPES: [],
        SHOW_TRAINING_TYPE_REPORT: true,
        ADD_SLOT_PERMISSION: true,
        SHOW_TOTAL_PRICE_REPORT: true,
        SORT_TRAININGS_BY_TIME: "DESC",
        SHOW_PAYMENT_MONEY_IN_PAYMENT_REPORT: true,
        SHOW_TOTAL_TERMINS: true,
        SHOW_INFINITY_TRAININGS: false,
        SHOW_USER_TRAINING_TYPE_ON_TRAINING: true,
        ADD_KEY_FOR_TRAINING: true,
        SHOW_ADD_TRAINER_ON_SLOT: false,
        SHOW_PACKAGE_MEMBERSHIP: false,
        LISTEN_FIREBASE_QR_SCAN: false,
        CUSTOM_LOCALIZATION: {
            EN: {
                "label_max_people_on_training": 'Number people on training',
                "label_name_for_partner": 'trainer'
            },
            SR: {
                "label_max_people_on_training": 'Broj ljudi na treningu',
                "label_name_for_partner": 'trener'
            }
        },
        TABS: "HOME,TRAININGS,REPORT_TR,TRN_TYPES,USERS,SCHEDULE,PAYMENTS,PARTNERS,MEMBERSHIPS,INVOICES,COMPANIES",
        RIGHT_TABS: "NUMBER_OF_TRAININGS,MY_MEMBER,ACCOUNT",
        IS_ENABLED_BOTTOM_BAR: true,
        HIDDEN_COLUMNS_USER_TABLE:"SHOES_SIZE,BAR_BALANCE"
    },

    BASCELIK: {
        NAME: "bascelik",
        HOME: "/home-page",
        WOD: null,
        TITLE: "Bas Celik",
        LOGIN_LOGO: '/bascelik/bascelik_logo.png',
        DEFAULT_TRAINING_TYPES: [],
        SHOW_TRAINING_TYPE_REPORT: true,
        ADD_SLOT_PERMISSION: true,
        SHOW_TOTAL_PRICE_REPORT: true,
        SORT_TRAININGS_BY_TIME: "DESC",
        SHOW_PAYMENT_MONEY_IN_PAYMENT_REPORT: true,
        SHOW_TOTAL_TERMINS: true,
        SHOW_INFINITY_TRAININGS: false,
        SHOW_USER_TRAINING_TYPE_ON_TRAINING: true,
        ADD_KEY_FOR_TRAINING: true,
        SHOW_ADD_TRAINER_ON_SLOT: true,
        SHOW_PACKAGE_MEMBERSHIP: true,
        LISTEN_FIREBASE_QR_SCAN: true,
        CUSTOM_LOCALIZATION: {
            EN: {
                "label_max_people_on_training": 'Number people on training',
                "label_name_for_partner": 'trainer'
            },
            SR: {
                "label_max_people_on_training": 'Broj ljudi na treningu',
                "label_name_for_partner": 'trener'
            }
        },
        TABS: "HOME,TRAININGS,REPORT_TR,TRN_TYPES,SHOP,USR_REPORT,USERS,WOD,SCHEDULE,PAYMENTS,PARTNERS,MEMBERSHIPS,INVOICES,COMPANIES",
        RIGHT_TABS: "NUMBER_OF_TRAININGS,MY_MEMBER,ACCOUNT",
        IS_ENABLED_BOTTOM_BAR: true,
        HIDDEN_COLUMNS_USER_TABLE:"SHOES_SIZE,BAR_BALANCE"
    },

    CUMBO: {
        NAME: "cumbo",
        HOME: "/articles",
        WOD: null,
        TITLE: "Cumbo",
        LOGIN_LOGO: '/cumbo/cumbo_logo.png',
        DEFAULT_TRAINING_TYPES: [],
        SHOW_TRAINING_TYPE_REPORT: true,
        ADD_SLOT_PERMISSION: true,
        SHOW_TOTAL_PRICE_REPORT: true,
        SORT_TRAININGS_BY_TIME: "DESC",
        SHOW_PAYMENT_MONEY_IN_PAYMENT_REPORT: true,
        SHOW_TOTAL_TERMINS: true,
        SHOW_INFINITY_TRAININGS: false,
        SHOW_USER_TRAINING_TYPE_ON_TRAINING: true,
        ADD_KEY_FOR_TRAINING: true,
        SHOW_ADD_TRAINER_ON_SLOT: false,
        SHOW_PACKAGE_MEMBERSHIP: false,
        LISTEN_FIREBASE_QR_SCAN: false,
        CUSTOM_LOCALIZATION: {
            EN: {
                "label_max_people_on_training": 'Number people on training',
                "label_name_for_partner": 'trainer',
                "label_a_category": "Brand",
                "label_a_sub_category": "Model",
                "label_a_code": "Imei",
                "label_role_trainer": "Employer",
            },
            SR: {
                "label_max_people_on_training": 'Broj ljudi na treningu',
                "label_name_for_partner": 'trener',
                "label_a_category": "Marka",
                "label_a_sub_category": "Model",
                "label_a_code": "Imei",
                "label_role_trainer": "Zaposleni",
            }
        },
        TABS: "USERS,ARTICLES,COMPANIES,CSCHEDULE,ARTICLE_REPORT",
        RIGHT_TABS: "ACCOUNT",
        IS_ENABLED_BOTTOM_BAR: false,
        HIDDEN_COLUMNS_USER_TABLE: "BIRTHDAY,BAR_BALANCE,NUMBER_OF_TRAININGS,SHOES_SIZE,NOT_COMING,PAID,EXPIRE,LOYALTY,PARTNER,PAYMENT_TYPE,BUTTON_PAYMENTS,DISABLE_USER_INFO,DEBTOR,MEMBERSHIP,EXTERNAL_PAR",
        SHOW_SORT_USERS: false,

    },

    TESTGYM: {
        NAME: "testgym",
        HOME: "/home-page",
        WOD: null,
        TITLE: "Test Gym",
        LOGIN_LOGO: '/testgym/testgym_logo.png',
        DEFAULT_TRAINING_TYPES: [],
        SHOW_TRAINING_TYPE_REPORT: true,
        ADD_SLOT_PERMISSION: true,
        SHOW_TOTAL_PRICE_REPORT: true,
        SORT_TRAININGS_BY_TIME: "ASC",
        SHOW_PAYMENT_MONEY_IN_PAYMENT_REPORT: true,
        SHOW_TOTAL_TERMINS: true,
        SHOW_INFINITY_TRAININGS: false,
        SHOW_USER_TRAINING_TYPE_ON_TRAINING: true,
        ADD_KEY_FOR_TRAINING: true,
        SHOW_ADD_TRAINER_ON_SLOT: true,
        SHOW_PACKAGE_MEMBERSHIP: true,
        LISTEN_FIREBASE_QR_SCAN: true,
        CUSTOM_LOCALIZATION: {
            EN: {
                "label_max_people_on_training": 'Number people on training',
                "label_name_for_partner": 'trainer'
            },
            SR: {
                "label_max_people_on_training": 'Broj ljudi na treningu',
                "label_name_for_partner": 'trener'
            }
        },
        //CAMPAIGN
        TABS: "HOME,BAR_POS,ENTRANCE,INVENTORY,BAR_SALDO_REPORT,ORDERS,CAMPAIGN,PROFIT,USR_REPORT,WAREHOUSE,SUBSCRIPTIONS,SHOP,CASHBACK_CREDIT,TRAININGS,WOD,PERSONAL,ORDR_RESERVATION,REPORT_TR,RPRT_TRAINER,TRN_TYPES,USERS,SCHEDULE,PAYMENTS,PARTNERS,COMPANY_PARTNERS,MEMBERSHIPS,INVOICES,COMPANIES,DOCUMENTATIONS",
        // TABS: "HOME,BAR_POS,ARTICLES,CSCHEDULE,ENTRANCE,TIMED_SLOTS,ORDERS,SHOP,CASHBACK_CREDIT,TRAININGS,WOD,PERSONAL,ORDR_RESERVATION,REPORT_TR,RPRT_TRAINER,TRN_TYPES,USERS,SCHEDULE,PAYMENTS,PARTNERS,COMPANY_PARTNERS,MEMBERSHIPS,INVOICES,COMPANIES,DOCUMENTATIONS",
        RIGHT_TABS: "NUMBER_OF_TRAININGS,MY_MEMBER,ACCOUNT",
        IS_ENABLED_BOTTOM_BAR: true,
        HIDDEN_COLUMNS_USER_TABLE:"",
        USER_TYPES: [
            {
                id: "USER_TYPE_ONLINE",
                label: 'label_user_type_online'
            },
            {
                id: "USER_TYPE_TRAINING_CENTER",
                label: 'label_user_type_training_center'
            },
            {
                id: "USER_TYPE_BOTH",
                label: 'label_user_type_both'
            },
            {
                id: "USER_TYPE_PERSONAL",
                label: 'label_user_type_personal'
            },
        ],
        SHOW_USER_ADDITIONAL_INFO: true,
        SHOW_USER_ADDITIONAL_INFO_LESSON_URL: true,
        ENABLE_GENDER: true,
        TRAINER_SEE_ONLY_OWN_SLOTS: false, //ovo je ako je na termin zalepljen trener prikazi samo te
        MUST_SELECT_TRAINER_WHEN_RESERVE_SLOT_AS_ADMIN: false,
        FILTER_TRAINER_ONLY_SLOT_WITH_OWN_CLIENTS: true, //ovo je prvo pokupim treninge pa vidim kome sve drzi treninge i te slotove prikazem
        ENABLE_REMOTE_OPEN_DOOR: true, //da li admin moze da otvori remote
        SHOW_VIEW_FILTER_FOR_TRAININGS: true, //da li imaju mogucnost da menjaju view na treninzima
        SHOW_MEMBERSHIP_FOR_PROGRAMS: true,
        USE_QR_SCANNER_FOCUS: true,
        ENABLE_NEW_DESIGN_OF_PERSONAL_PROGRAMS: true,
        ENABLE_CHAT: true
    },

    GLOBAL_PANEL: {
        NAME: "testgym",
        HOME: "/home-page",
        WOD: null,
        TITLE: "Admin panel",
        LOGIN_LOGO: '/testgym/testgym_logo.png',
        DEFAULT_TRAINING_TYPES: [],
        SHOW_TRAINING_TYPE_REPORT: true,
        ADD_SLOT_PERMISSION: true,
        SHOW_TOTAL_PRICE_REPORT: true,
        SORT_TRAININGS_BY_TIME: "ASC",
        SHOW_PAYMENT_MONEY_IN_PAYMENT_REPORT: true,
        SHOW_TOTAL_TERMINS: true,
        SHOW_INFINITY_TRAININGS: false,
        SHOW_USER_TRAINING_TYPE_ON_TRAINING: true,
        ADD_KEY_FOR_TRAINING: true,
        SHOW_ADD_TRAINER_ON_SLOT: true,
        SHOW_PACKAGE_MEMBERSHIP: true,
        LISTEN_FIREBASE_QR_SCAN: true,
        CUSTOM_LOCALIZATION: {
            EN: {
                "label_max_people_on_training": 'Number people on training',
                "label_name_for_partner": 'trainer'
            },
            SR: {
                "label_max_people_on_training": 'Broj ljudi na treningu',
                "label_name_for_partner": 'trener'
            }
        },

        TABS: "HOME,BAR_POS,ENTRANCE,INVENTORY,BAR_SALDO_REPORT,ORDERS,CAMPAIGN,PROFIT,USR_REPORT,WAREHOUSE,SUBSCRIPTIONS,SHOP,CASHBACK_CREDIT,TRAININGS,WOD,PERSONAL,ORDR_RESERVATION,REPORT_TR,RPRT_TRAINER,TRN_TYPES,USERS,SCHEDULE,PAYMENTS,PARTNERS,COMPANY_PARTNERS,MEMBERSHIPS,INVOICES,COMPANIES,DOCUMENTATIONS",
        RIGHT_TABS: "NUMBER_OF_TRAININGS,MY_MEMBER,ACCOUNT",
        IS_ENABLED_BOTTOM_BAR: true,
        HIDDEN_COLUMNS_USER_TABLE:"",
        USER_TYPES: [
            {
                id: "USER_TYPE_ONLINE",
                label: 'label_user_type_online'
            },
            {
                id: "USER_TYPE_TRAINING_CENTER",
                label: 'label_user_type_training_center'
            },
            {
                id: "USER_TYPE_BOTH",
                label: 'label_user_type_both'
            },
            {
                id: "USER_TYPE_PERSONAL",
                label: 'label_user_type_personal'
            },
        ],
        SHOW_USER_ADDITIONAL_INFO: true,
        SHOW_USER_ADDITIONAL_INFO_LESSON_URL: true,
        ENABLE_GENDER: true,
        TRAINER_SEE_ONLY_OWN_SLOTS: false, //ovo je ako je na termin zalepljen trener prikazi samo te
        MUST_SELECT_TRAINER_WHEN_RESERVE_SLOT_AS_ADMIN: false,
        FILTER_TRAINER_ONLY_SLOT_WITH_OWN_CLIENTS: true, //ovo je prvo pokupim treninge pa vidim kome sve drzi treninge i te slotove prikazem
        ENABLE_REMOTE_OPEN_DOOR: true, //da li admin moze da otvori remote
        SHOW_VIEW_FILTER_FOR_TRAININGS: true, //da li imaju mogucnost da menjaju view na treninzima
        SHOW_MEMBERSHIP_FOR_PROGRAMS: true,
        USE_QR_SCANNER_FOCUS: true,
        ENABLE_NEW_DESIGN_OF_PERSONAL_PROGRAMS: true,
        FORCE_CODE_ON_LOGIN: true
    },

    PRVITIM: {
        NAME: "prvitim",
        HOME: "/home-page",
        WOD: null,
        TITLE: "Prvi tim",
        LOGIN_LOGO: '/prvitim/prvitim_logo.svg',
        DEFAULT_TRAINING_TYPES: [],
        SHOW_TRAINING_TYPE_REPORT: true,
        ADD_SLOT_PERMISSION: true,
        SHOW_TOTAL_PRICE_REPORT: true,
        SORT_TRAININGS_BY_TIME: "ASC",
        SHOW_PAYMENT_MONEY_IN_PAYMENT_REPORT: true,
        SHOW_TOTAL_TERMINS: true,
        SHOW_INFINITY_TRAININGS: false,
        SHOW_USER_TRAINING_TYPE_ON_TRAINING: true,
        ADD_KEY_FOR_TRAINING: true,
        SHOW_ADD_TRAINER_ON_SLOT: true,
        SHOW_PACKAGE_MEMBERSHIP: true,
        LISTEN_FIREBASE_QR_SCAN: true,
        ENABLE_REMOTE_OPEN_DOOR: true,
        CUSTOM_LOCALIZATION: {
            EN: {
                "label_max_people_on_training": 'Number people on training',
                "label_name_for_partner": 'trainer'
            },
            SR: {
                "label_max_people_on_training": 'Broj ljudi na treningu',
                "label_name_for_partner": 'trener'
            }
        },
        TABS: "HOME,ENTRANCE,BAR_POS,ORDERS,PROFIT,BAR_SALDO_REPORT,USR_REPORT,WAREHOUSE,CASHBACK_CREDIT,TRAININGS,EMPLOYED_USR,EMPLOYED_TRM,RPRT_TRAINER,REPORT_TR,SHOP,TRN_TYPES,USERS,SCHEDULE,PAYMENTS,PARTNERS,MEMBERSHIPS,INVOICES,COMPANIES",
        RIGHT_TABS: "NUMBER_OF_TRAININGS,MY_MEMBER,ACCOUNT",
        IS_ENABLED_BOTTOM_BAR: true,
        HIDDEN_COLUMNS_USER_TABLE:"SHOES_SIZE",
        USE_QR_SCANNER_FOCUS: true
    },

    DENTAL_TEST: {
        NAME: "dentaltest",
        HOME: "/home-page",
        WOD: null,
        TITLE: "Dental Test",
        LOGIN_LOGO: '/testgym/testgym_logo.png',
        DEFAULT_TRAINING_TYPES: [""],
        SHOW_TRAINING_TYPE_REPORT: true,
        ADD_SLOT_PERMISSION: true,
        SHOW_TOTAL_PRICE_REPORT: true,
        SORT_TRAININGS_BY_TIME: "ASC",
        SHOW_PAYMENT_MONEY_IN_PAYMENT_REPORT: true,
        SHOW_TOTAL_TERMINS: true,
        SHOW_INFINITY_TRAININGS: false,
        SHOW_USER_TRAINING_TYPE_ON_TRAINING: true,
        ADD_KEY_FOR_TRAINING: true,
        SHOW_ADD_TRAINER_ON_SLOT: true,
        SHOW_PACKAGE_MEMBERSHIP: true,
        LISTEN_FIREBASE_QR_SCAN: true,
        CUSTOM_LOCALIZATION: {
            EN: {
                "label_max_people_on_training": 'Number people on slot',
                "label_name_for_partner": 'partner',
                "label_trainings": 'Terms',
                "label_ci_training_add": 'Add new service',
                "label_trainers": 'Doctors',
            },
            SR: {
                "label_max_people_on_training": 'Broj ljudi na terminu',
                "label_name_for_partner": 'partner',
                "label_trainings": 'Termini',
                "label_ci_training_add": 'Dodaj novu uslugu',
                "label_trainers": 'Doktori',
            }
        },
        TABS: "HOME,TRAININGS,REPORT_TR,TRN_TYPES,USERS,SCHEDULE,PAYMENTS,PARTNERS,MEMBERSHIPS,INVOICES,COMPANIES",
        RIGHT_TABS: "NUMBER_OF_TRAININGS,MY_MEMBER,ACCOUNT",
        IS_ENABLED_BOTTOM_BAR: true,
        HIDDEN_COLUMNS_USER_TABLE:"SHOES_SIZE"
    },

    DYNAMIC_COMPANY: {
        NAME: "dynamic",
        HOME: "/home-page",
        WOD: null,
        TITLE: "Test Gym",
        LOGIN_LOGO: '/testgym/testgym_logo.png',
        DEFAULT_TRAINING_TYPES: [""],
        SHOW_TRAINING_TYPE_REPORT: true,
        ADD_SLOT_PERMISSION: true,
        SHOW_TOTAL_PRICE_REPORT: true,
        SORT_TRAININGS_BY_TIME: "ASC",
        SHOW_PAYMENT_MONEY_IN_PAYMENT_REPORT: true,
        SHOW_TOTAL_TERMINS: true,
        SHOW_INFINITY_TRAININGS: false,
        SHOW_USER_TRAINING_TYPE_ON_TRAINING: true,
        ADD_KEY_FOR_TRAINING: true,
        SHOW_ADD_TRAINER_ON_SLOT: true,
        SHOW_PACKAGE_MEMBERSHIP: true,
        LISTEN_FIREBASE_QR_SCAN: true,
        CUSTOM_LOCALIZATION: {
            EN: {
                "label_max_people_on_training": 'Number people on training',
                "label_name_for_partner": 'trainer'
            },
            SR: {
                "label_max_people_on_training": 'Broj ljudi na treningu',
                "label_name_for_partner": 'trener'
            }
        },
        TABS: "HOME,ENTRANCE,ORDERS,SHOP,CASHBACK_CREDIT,USR_REPORT,TRAININGS,WOD,PERSONAL,REPORT_TR,TRN_TYPES,USERS,SCHEDULE,PAYMENTS,PARTNERS,COMPANY_PARTNERS,MEMBERSHIPS,INVOICES,COMPANIES",
        RIGHT_TABS: "NUMBER_OF_TRAININGS,MY_MEMBER,ACCOUNT",
        IS_ENABLED_BOTTOM_BAR: true,
        HIDDEN_COLUMNS_USER_TABLE:"SHOES_SIZE",
        USER_TYPES: [
            {
                id: "USER_TYPE_ONLINE",
                label: 'label_user_type_online'
            },
            {
                id: "USER_TYPE_TRAINING_CENTER",
                label: 'label_user_type_training_center'
            },
            {
                id: "USER_TYPE_BOTH",
                label: 'label_user_type_both'
            },
        ]
    },

    ONLINEENGLESKI: {
        NAME: "onlineengleski",
        HOME: "/home-page",
        WOD: null,
        TITLE: "Online engleski",
        LOGIN_LOGO: '/testgym/testgym_logo.png',
        DEFAULT_TRAINING_TYPES: [""],
        SHOW_TRAINING_TYPE_REPORT: true,
        ADD_SLOT_PERMISSION: true,
        SHOW_TOTAL_PRICE_REPORT: true,
        SORT_TRAININGS_BY_TIME: "ASC",
        SHOW_PAYMENT_MONEY_IN_PAYMENT_REPORT: true,
        SHOW_TOTAL_TERMINS: true,
        SHOW_INFINITY_TRAININGS: false,
        SHOW_USER_TRAINING_TYPE_ON_TRAINING: true,
        ADD_KEY_FOR_TRAINING: true,
        SHOW_ADD_TRAINER_ON_SLOT: true,
        SHOW_PACKAGE_MEMBERSHIP: true,
        LISTEN_FIREBASE_QR_SCAN: true,
        CUSTOM_LOCALIZATION: {
            EN: {
                "label_max_people_on_training": 'Number people on slot',
                "label_name_for_partner": 'partner',
                "label_trainings": 'Časovi',
                "label_ci_training_add": 'Add new service',
                "label_trainers": 'Profesors',
                "t_my_trainings": "My Trainings",
                "label_trainings_report": "Training Report",
                "label_training_success_reserved": "Training successfully reserved.",
                "label_show_my_trainings": "Show only my trainings",
                "label_number_of_trainings": "Number of Trainings",
                "label_success_add_termin": "Training successfully reserved.",
                "label_success_remove_termin": "Training successfully canceled.",
                "label_remove_termin_title": "Cancel Training",
                "label_remove_termin_title_are_you_sure": "Are you sure you want to cancel this training?",
                "label_back_termin": "Return Training",
                "label_back_termin_are_you_sure": "Are you sure you want to return the training to the user?",
                "label_my_termini": "My Trainings",
                "label_scheduled_termini": "Scheduled Trainings",
                "label_no_scheduled_termini": "No scheduled trainings",
                "label_termin_type_title": "Training Type",
                "label_reserve_termin": "Reserve Training",
                "label_add_user_to_termin": "Add user to training",
                "label_rest_termini": "Remaining Trainings",
                "label_termin_removed_success": "Training successfully removed",
                "label_termin_add_success": "Training successfully added",
                "label_rest_of_termini": "Remaining Trainings",
                "label_choose_termini": "Choose Trainings",
                "label_payment_num_termini": "Number of Trainings",
                "label_payment_type_termini": "Training Type",
                "label_payment_error_choose_type": "Choose a training type",
                "label_active_payment_tr_numbers": "Paid Trainings",
                "label_active_payment_type": "Training Type",
                "label_add_new_type_termini": "Add new training type",
                "label_open_termini_for": "Open trainings for",
                "label_open_termini_success": "Training successfully opened.",
                "label_termin_history": "Training History",
                "label_termin_history_is_empty": "Training history is empty",
                "label_max_people_on_termin": "Max people per training",
                "label_ci_termin_add": "Add New Training",
                "label_ci_termin_name": "Training Name",
                "label_ci_termin_minutes": "Training Duration (minutes)",
                "label_ci_termin_intensity": "Training Intensity (0 - 5)",
                "label_ci_termin_success_add": "Training successfully added",
                "label_ci_termin_name_en": "Training Name (en)",
                "label_set_termini_number": "Set number of trainings",
                "label_approve_are_you_sure": "Are you sure you want to approve the training for:",
                "label_success_approved_termin": "Training successfully approved",
                "label_delete_and_cancel_all_users": "Delete and cancel all trainings",
                "label_add_td": "Add New Training",
                "label_td_name": "Training Name",
                "label_td_name_en": "Training Name (en)",
                "label_delete_termin_of_the_day_successfully": "Training successfully deleted",
                "label_delete_termin_of_the_day": "Delete Training",
                "label_delete_termin_of_the_day_are_you_sure": "Are you sure you want to delete this training",
                "label_success_added_termin_of_the_day": "Training successfully added",
                "label_choose_exist_termin": "Choose Existing Training",
                "label_search_termini_definition": "Search Trainings",
                "label_edit_td": "Edit Training",
                "label_success_edited_termin_of_the_day": "Training successfully edited",
                "label_all_wod_termini": "View All Trainings",
                "label_all_wod_termini_title": "View All WOD Trainings",
                "label_termin_types": "Training Types",
                "label_ci_nutrition_add": "Add New Item",
                "label_ci_nutrition": "Blog",
                "label_ci_nutrition_name": "Item Name",
                "label_ci_nutrition_name_en": "Item Name (en)",
                "label_role_trainer": "Professor",
                "label_ci_trainer_add": "Add New Professor",
                "label_ci_trainer_name": "Professor Name",
                "label_ci_trainer_name_en": "Professor Name (en)",
                "label_trainer_name": "Professor",
                "label_training_type_title": "Class Type",
                "label_add_user_to_term": "Add User to Class",
                "label_training_types": "Class types",
                "label_partners": "Professors"
            },
            SR: {
                "label_max_people_on_training": 'Broj ljudi na terminu',
                "label_name_for_partner": 'Profesor',
                "label_trainings": 'Časovi',
                "label_ci_training_add": 'Dodaj novu uslugu',
                "label_trainers": 'Profesori',
                "t_my_trainings": "Moji termini",
                "label_trainings_report": "Izveštaj termina",
                "label_training_success_reserved": "Termin uspešno rezervisan.",
                "label_show_my_trainings": "Prikaži samo moje termine",
                "label_number_of_trainings": "Broj termina",
                "label_success_add_termin": "Uspešno rezervisan termin.",
                "label_success_remove_termin": "Uspešno otkazan termin.",
                "label_remove_termin_title": "Otkazivanje termina",
                "label_remove_termin_title_are_you_sure": "Da li želite da otkažete termin?",
                "label_back_termin": "Vraćanje termina",
                "label_back_termin_are_you_sure": "Da li želite da vratite termin korisniku?",
                "label_my_termini": "Moji termini",
                "label_scheduled_termini": "Zakazani termini",
                "label_no_scheduled_termini": "Nema zakazanih termina",
                "label_termin_type_title": "Tip termina",
                "label_reserve_termin": "Rezerviši termin",
                "label_add_user_to_termin": "Dodaj korisnika na termin",
                "label_rest_termini": "Ostatak termina",
                "label_termin_removed_success": "Uspešno skinut termin",
                "label_termin_add_success": "Uspešno dodat termin",
                "label_rest_of_termini": "Preostalo termina",
                "label_choose_termini": "Izaberi termine",
                "label_payment_num_termini": "Broj termina",
                "label_payment_type_termini": "Tip termina",
                "label_payment_error_choose_type": "Izaberite tip termina",
                "label_active_payment_tr_numbers": "Uplaćeno termina",
                "label_active_payment_type": "Tip termina",
                "label_add_new_type_termini": "Dodaj novi tip termina",
                "label_open_termini_for": "Otvori termine za",
                "label_open_termini_success": "Termin uspešno otvoreni termini.",
                "label_termin_history": "Istorija termina",
                "label_termin_history_is_empty": "Istorija termina je prazna",
                "label_max_people_on_termin": "Broj ljudi na terminu",
                "label_ci_termin_add": "Dodaj novi termin",
                "label_ci_termin_name": "Ime termina",
                "label_ci_termin_minutes": "Trajanje termina u minutama",
                "label_ci_termin_intensity": "Itezitet termina (0 - 5)",
                "label_ci_termin_success_add": "Uspešno dodat termin",
                "label_ci_termin_name_en": "Ime termina (en)",
                "label_set_termini_number": "Postavi broj termina",
                "label_approve_are_you_sure": "Da li ste sigurni da želite da potvrdite termin za:",
                "label_success_approved_termin": "Uspešno potvrđen termin",
                "label_delete_and_cancel_all_users": "Obriši i otkaži sve termine",
                "label_add_td": "Dodaj novi termin",
                "label_td_name": "Ime termina",
                "label_td_name_en": "Ime termina (en)",
                "label_delete_termin_of_the_day_successfully": "Uspešno obrisan termin",
                "label_delete_termin_of_the_day": "Brisanje termina",
                "label_delete_termin_of_the_day_are_you_sure": "Da li ste sigurni da želite da obrišete termin",
                "label_success_added_termin_of_the_day": "Uspešno dodat termin",
                "label_choose_exist_termin": "Izaberi postojeći termin",
                "label_search_termini_definition": "Pretraži termine",
                "label_edit_td": "Izmeni termin",
                "label_success_edited_termin_of_the_day": "Uspešno izmenjen termin",
                "label_all_wod_termini": "Pregled svih termina",
                "label_all_wod_termini_title": "Pregled svih WOD termina",
                "label_termin_types": "Vrste termina",
                "label_ci_nutrition_add": "Dodaj novu stavku",
                "label_ci_nutrition": "Blog",
                "label_ci_nutrition_name": "Ime stave",
                "label_ci_nutrition_name_en": "Ime stave (en)",
                "label_role_trainer":"Profesor",
                "label_ci_trainer_add": "Dodaj novog profesora",
                "label_ci_trainer_name": "Ime profesora",
                "label_ci_trainer_name_en": "Ime profesora (en)",
                'label_trainer_name': 'Profesor',
                "label_training_type_title": "Tip časa",
                "label_add_user_to_term": "Dodaj korisnika na čas",
                "label_training_types": "Vrste časova",
                "label_partners": "Profesori"
            }
        },
        TABS: "HOME,TRAININGS,REPORT_TR,TRN_TYPES,USR_REPORT,EMPLOYED_USR,EMPLOYED_TRM,USERS,SCHEDULE,PAYMENTS,PARTNERS,COMPANY_PARTNERS,MEMBERSHIPS,INVOICES,COMPANIES",
        RIGHT_TABS: "NUMBER_OF_TRAININGS,MY_MEMBER,ACCOUNT",
        IS_ENABLED_BOTTOM_BAR: true,
        HIDDEN_COLUMNS_USER_TABLE:"SHOES_SIZE,BAR_BALANCE",
        USER_TYPES: []
    },

    ACTIVEHUMANS: {
        NAME: "activehumans",
        HOME: "/home-page",
        WOD: null,
        TITLE: "Test Gym",
        LOGIN_LOGO: '/activehumans/activehumans.png',
        DEFAULT_TRAINING_TYPES: [],
        SHOW_TRAINING_TYPE_REPORT: true,
        ADD_SLOT_PERMISSION: true,
        SHOW_TOTAL_PRICE_REPORT: true,
        SORT_TRAININGS_BY_TIME: "ASC",
        SHOW_PAYMENT_MONEY_IN_PAYMENT_REPORT: true,
        SHOW_TOTAL_TERMINS: true,
        SHOW_INFINITY_TRAININGS: false,
        SHOW_USER_TRAINING_TYPE_ON_TRAINING: true,
        ADD_KEY_FOR_TRAINING: true,
        SHOW_ADD_TRAINER_ON_SLOT: true,
        SHOW_PACKAGE_MEMBERSHIP: true,
        LISTEN_FIREBASE_QR_SCAN: true,
        CUSTOM_LOCALIZATION: {
            EN: {
                "label_max_people_on_training": 'Number people on training',
                "label_name_for_partner": 'trainer',
                "label_trainers": 'Partners',
            },
            SR: {
                "label_max_people_on_training": 'Broj ljudi na treningu',
                "label_name_for_partner": 'trener',
                "label_trainers": 'Partneri',
            }
        },
        TABS: "HOME,ORDERS,SHOP,CASHBACK_CREDIT,PERSONAL,PROFIT,USR_REPORT,TRN_TYPES,USERS,PAYMENTS,PARTNERS,COMPANY_PARTNERS,MEMBERSHIPS,INVOICES,COMPANIES",
        RIGHT_TABS: "ACCOUNT",
        IS_ENABLED_BOTTOM_BAR: true,
        HIDDEN_COLUMNS_USER_TABLE:"BAR_BALANCE",
        USER_TYPES: [
            {
                id: "USER_TYPE_ONLINE",
                label: 'label_user_type_online'
            },
            {
                id: "USER_TYPE_PERSONAL",
                label: 'label_user_type_personal'
            },
        ],
        SHOW_USER_ADDITIONAL_INFO: false,
        SHOW_USER_ADDITIONAL_INFO_LESSON_URL: false,
        ENABLE_GENDER: true
    },

    DZONY_GYM: {
        NAME: "dzonygym",
        HOME: "/home-page",
        WOD: null,
        TITLE: "Dzony Gym",
        LOGIN_LOGO: '/dzony_gym/dzony_logo.png',
        DEFAULT_TRAINING_TYPES: [],
        SHOW_TRAINING_TYPE_REPORT: true,
        ADD_SLOT_PERMISSION: true,
        SHOW_TOTAL_PRICE_REPORT: true,
        SORT_TRAININGS_BY_TIME: "ASC",
        SHOW_PAYMENT_MONEY_IN_PAYMENT_REPORT: true,
        SHOW_TOTAL_TERMINS: true,
        SHOW_INFINITY_TRAININGS: false,
        SHOW_USER_TRAINING_TYPE_ON_TRAINING: true,
        ADD_KEY_FOR_TRAINING: true,
        SHOW_ADD_TRAINER_ON_SLOT: true,
        SHOW_PACKAGE_MEMBERSHIP: true,
        LISTEN_FIREBASE_QR_SCAN: true,
        CUSTOM_LOCALIZATION: {
            EN: {
                "label_max_people_on_training": 'Number people on training',
                "label_name_for_partner": 'trainer',
                "label_terms":"Schedule",
            },
            SR: {
                "label_max_people_on_training": 'Broj ljudi na treningu',
                "label_name_for_partner": 'trener',
                "label_terms":"Stalni raspored",
            }
        },
        TABS: "HOME,ENTRANCE,TRAININGS,SHOP,ORDERS,PERSONAL,USR_REPORT,EMPLOYED_USR,REPORT_TR,TRN_TYPES,USERS,SCHEDULE,PAYMENTS,PARTNERS,MEMBERSHIPS,INVOICES,COMPANIES,DOCUMENTATIONS",
        RIGHT_TABS: "NUMBER_OF_TRAININGS,MY_MEMBER,ACCOUNT",
        IS_ENABLED_BOTTOM_BAR: true,
        HIDDEN_COLUMNS_USER_TABLE: "BIRTHDAY,SHOES_SIZE,NOT_COMING,LOYALTY,PARTNER,EXTERNAL_PAR,BAR_BALANCE",
        SHOW_USER_ADDITIONAL_INFO: false,
        SHOW_USER_ADDITIONAL_INFO_LESSON_URL: false,
        ENABLE_GENDER: true,
        ENABLE_REMOTE_OPEN_DOOR: true,
        USE_QR_SCANNER_FOCUS: true,
        ENABLE_NEW_DESIGN_OF_PERSONAL_PROGRAMS: true
    },

    ZONE_PERFORMANCE: {
        NAME: "zonep",
        HOME: "/home-page",
        WOD: null,
        TITLE: "Zone Performance",
        LOGIN_LOGO: '/zonep/zonep.png',
        DEFAULT_TRAINING_TYPES: [],
        SHOW_TRAINING_TYPE_REPORT: true,
        ADD_SLOT_PERMISSION: true,
        SHOW_TOTAL_PRICE_REPORT: true,
        SORT_TRAININGS_BY_TIME: "ASC",
        SHOW_PAYMENT_MONEY_IN_PAYMENT_REPORT: true,
        SHOW_TOTAL_TERMINS: true,
        SHOW_INFINITY_TRAININGS: false,
        SHOW_USER_TRAINING_TYPE_ON_TRAINING: true,
        ADD_KEY_FOR_TRAINING: true,
        SHOW_ADD_TRAINER_ON_SLOT: true,
        SHOW_PACKAGE_MEMBERSHIP: true,
        LISTEN_FIREBASE_QR_SCAN: true,
        CUSTOM_LOCALIZATION: {
            EN: {
                "label_max_people_on_training": 'Number people on training',
                "label_name_for_partner": 'trainer',
                "label_terms":"Schedule",
            },
            SR: {
                "label_max_people_on_training": 'Broj ljudi na treningu',
                "label_name_for_partner": 'trener',
                "label_terms":"Stalni raspored",
            }
        },
        // TABS: "HOME,TRAININGS,SHOP,ORDERS,REPORT_TR,TRN_TYPES,USERS,SCHEDULE,PAYMENTS,MEMBERSHIPS,INVOICES,COMPANIES,DOCUMENTATIONS",
        TABS: "HOME,TRAININGS,BAR_POS,ORDERS,PROFIT,USR_REPORT,ORDR_RESERVATION,SHOP,CASHBACK_CREDIT,REPORT_TR,EMPLOYED_USR,EMPLOYED_TRM,RPRT_TRAINER,TRN_TYPES,USERS,SCHEDULE,PAYMENTS,PARTNERS,MEMBERSHIPS,INVOICES,COMPANIES,DOCUMENTATIONS",
        RIGHT_TABS: "NUMBER_OF_TRAININGS,ACCOUNT",
        IS_ENABLED_BOTTOM_BAR: true,
        HIDDEN_COLUMNS_USER_TABLE: "BIRTHDAY,SHOES_SIZE,NOT_COMING,LOYALTY,PARTNER,EXTERNAL_PAR",
        SHOW_USER_ADDITIONAL_INFO: true,
        SHOW_USER_ADDITIONAL_INFO_LESSON_URL: false,
        ENABLE_GENDER: true,
        TRAINER_CAN_ADD_NOTIFICATION: true,
        MUST_SELECT_TRAINER_WHEN_RESERVE_SLOT_AS_ADMIN: false,
        SHOW_VIEW_FILTER_FOR_TRAININGS: true, //da li imaju mogucnost da menjaju view na treninzima,
        USE_QR_SCANNER_FOCUS: false,
        ADD_NUMBER_TRAININGS_WITH_NEW_PAYMENT_DEFAULT_VALUE: false
    },

    HARMONIJA: {
        NAME: "harmonija",
        HOME: "/home-page",
        WOD: null,
        TITLE: "Harmonija Fitness",
        LOGIN_LOGO: '/testgym/testgym_logo.png',
        DEFAULT_TRAINING_TYPES: [],
        SHOW_TRAINING_TYPE_REPORT: true,
        ADD_SLOT_PERMISSION: true,
        SHOW_TOTAL_PRICE_REPORT: true,
        SORT_TRAININGS_BY_TIME: "ASC",
        SHOW_PAYMENT_MONEY_IN_PAYMENT_REPORT: true,
        SHOW_TOTAL_TERMINS: true,
        SHOW_INFINITY_TRAININGS: false,
        SHOW_USER_TRAINING_TYPE_ON_TRAINING: true,
        ADD_KEY_FOR_TRAINING: true,
        SHOW_ADD_TRAINER_ON_SLOT: true,
        SHOW_PACKAGE_MEMBERSHIP: true,
        LISTEN_FIREBASE_QR_SCAN: true,
        CUSTOM_LOCALIZATION: {
            EN: {
                "label_max_people_on_training": 'Number people on training',
                "label_name_for_partner": 'trainer',
                "label_terms":"Schedule",
                "label_trainings": "Slots",
            },
            SR: {
                "label_max_people_on_training": 'Broj ljudi na treningu',
                "label_name_for_partner": 'trener',
                "label_terms":"Stalni raspored",
                "label_trainings": "Termini",
            }
        },
        TABS: "HOME,TRAININGS,REPORT_TR,TRN_TYPES,USR_REPORT,USERS,RPRT_TRAINER,SCHEDULE,PAYMENTS,MEMBERSHIPS,INVOICES,COMPANIES,PARTNERS,DOCUMENTATIONS",
        RIGHT_TABS: "NUMBER_OF_TRAININGS,MY_MEMBER,ACCOUNT",
        IS_ENABLED_BOTTOM_BAR: true,
        HIDDEN_COLUMNS_USER_TABLE:"NOT_COMING,PARTNER,SHOES_SIZE,EXTERNAL_PAR,BAR_BALANCE",
        SHOW_USER_ADDITIONAL_INFO: true,
        SHOW_USER_ADDITIONAL_INFO_LESSON_URL: true,
        ENABLE_GENDER: true,
        TRAINER_SEE_ONLY_OWN_SLOTS: false,
        MUST_SELECT_TRAINER_WHEN_RESERVE_SLOT_AS_ADMIN: true,
        SHOW_ONLY_FREE_SLOTS: true,
        FILTER_TRAINER_ONLY_SLOT_WITH_OWN_CLIENTS: true,
        HIDDEN_COLUMNS_TRAINING_TABLE: "NOT_ARRIVED,EQUIPMENTS,KEYS",
        SHOW_TRAINER_ON_TRAININGS_PAGE: true,
        TRAINING_SALARY_PERCENTAGE: 0.5,
        TRAINING_TYPE_PRICES: {
            "Masaza Limfna drenaza 30": 2500,
            "Masaza Stopala 30": 2400,
            "Masaza Antistres 90": 4800,
            "Masaza Terapeutska 90": 5000,
            "Masaza Aromaterapija 90": 4900,
            "Masaza Limfna drenaza 90": 3300,
            "Masaza Maderoterapija 45": 2600,
            "Masaza Anticelulit 30": 2450,
            "Masaza Terapeutska 45": 3500,
            "Masaza Svecom 60": 4100,
            "Masaza Relaks 90": 4700,
            "Masaza Parcijalna 45": 2900,
            "Masaza Sportska 45": 3900,
            "Masaza Vacuslim 48": 3000,
            "Masaza Kamenjem 60": 4300,
            "Masaza Piling Celog Tela": 5800,
            "Masaza Antistres 60": 3900,
            "Masaza Antistres 45": 3400,
            "Masaza Aromaterapija 60": 4000,
            "Masaza Terapeutska 60": 4100,
            "Masaza Relaks 45": 3300,
            "Masaza Anticelulit 45": 2850,
            "Masaza Parcijalna 30": 2400,
            "Masaza Zlatna 90": 5500,
            "Masaza Relaks 60": 3800,
            "Masaza Maderoterapija 30": 2300,
            "Masaza Limfna drenaza 45": 2900
        }
    },

    FLAMINGO: {
        NAME: "flamingo",
        HOME: "/home-page",
        WOD: null,
        TITLE: "Termin Master",
        LOGIN_LOGO: '/testgym/testgym_logo.png',
        DEFAULT_TRAINING_TYPES: [],
        SHOW_TRAINING_TYPE_REPORT: true,
        ADD_SLOT_PERMISSION: true,
        SHOW_TOTAL_PRICE_REPORT: true,
        SORT_TRAININGS_BY_TIME: "ASC",
        SHOW_PAYMENT_MONEY_IN_PAYMENT_REPORT: true,
        SHOW_TOTAL_TERMINS: true,
        SHOW_INFINITY_TRAININGS: false,
        SHOW_USER_TRAINING_TYPE_ON_TRAINING: true,
        ADD_KEY_FOR_TRAINING: true,
        SHOW_ADD_TRAINER_ON_SLOT: true,
        SHOW_PACKAGE_MEMBERSHIP: true,
        LISTEN_FIREBASE_QR_SCAN: true,
        CUSTOM_LOCALIZATION: {
            EN: {
                "label_max_people_on_training": 'Number people on training',
                "label_name_for_partner": 'trainer'
            },
            SR: {
                "label_max_people_on_training": 'Broj ljudi na treningu',
                "label_name_for_partner": 'trener'
            }
        },
        TABS: "HOME,ENTRANCE,ENTRA_TRAINER,TRAININGS,USR_REPORT,REPORT_TR,EMPLOYED_USR,EMPLOYED_TRM,RPRT_TRAINER,TRN_TYPES,USERS,SCHEDULE,PAYMENTS,PARTNERS,MEMBERSHIPS,INVOICES,COMPANIES,DOCUMENTATIONS",
        RIGHT_TABS: "NUMBER_OF_TRAININGS,MY_MEMBER,ACCOUNT",
        IS_ENABLED_BOTTOM_BAR: true,
        HIDDEN_COLUMNS_USER_TABLE: "BAR_BALANCE",
        USER_TYPES: [
            {
                id: "USER_TYPE_ONLINE",
                label: 'label_user_type_online'
            },
            {
                id: "USER_TYPE_TRAINING_CENTER",
                label: 'label_user_type_training_center'
            },
            {
                id: "USER_TYPE_BOTH",
                label: 'label_user_type_both'
            },
        ],
        SHOW_USER_ADDITIONAL_INFO: true,
        SHOW_USER_ADDITIONAL_INFO_LESSON_URL: true,
        ENABLE_GENDER: true,
        TRAINER_SEE_ONLY_OWN_SLOTS: false, //ovo je ako je na termin zalepljen trener prikazi samo te
        MUST_SELECT_TRAINER_WHEN_RESERVE_SLOT_AS_ADMIN: false,
        FILTER_TRAINER_ONLY_SLOT_WITH_OWN_CLIENTS: true, //ovo je prvo pokupim treninge pa vidim kome sve drzi treninge i te slotove prikazem
        ENABLE_REMOTE_OPEN_DOOR: true, //ovo je prvo pokupim treninge pa vidim kome sve drzi treninge i te slotove prikazem
        SHOW_VIEW_FILTER_FOR_TRAININGS: true, //da li imaju mogucnost da menjaju view na treninzima
        SHOW_MEMBERSHIP_FOR_PROGRAMS: true,
        USE_QR_SCANNER_FOCUS: true
    },

    SAUNA_BAR: {
        NAME: "saunabar",
        HOME: "/home-page",
        WOD: null,
        TITLE: "Termin Master",
        LOGIN_LOGO: '/testgym/testgym_logo.png',
        DEFAULT_TRAINING_TYPES: [],
        SHOW_TRAINING_TYPE_REPORT: true,
        ADD_SLOT_PERMISSION: true,
        SHOW_TOTAL_PRICE_REPORT: true,
        SORT_TRAININGS_BY_TIME: "ASC",
        SHOW_PAYMENT_MONEY_IN_PAYMENT_REPORT: true,
        SHOW_TOTAL_TERMINS: true,
        SHOW_INFINITY_TRAININGS: false,
        SHOW_USER_TRAINING_TYPE_ON_TRAINING: true,
        ADD_KEY_FOR_TRAINING: true,
        SHOW_ADD_TRAINER_ON_SLOT: true,
        SHOW_PACKAGE_MEMBERSHIP: true,
        LISTEN_FIREBASE_QR_SCAN: true,
        CUSTOM_LOCALIZATION: {
            EN: {
                "label_max_people_on_training": 'Number people on terminu',
                "label_name_for_partner": 'trainer',
                "label_current_busy": "Trenutna gužva",
                "label_timed_slots": "Saunas",
                "label_trainings": "Terms",
                "label_ci_training_add": "Add new service",
                "label_trainers": "Trainer",
                "t_my_trainings": "My terms",
                "label_trainings_report": "Terms report",
                "label_training_success_reserved": "Term successfully reserved.",
                "label_show_my_trainings": "Show only my terms",
                "label_number_of_trainings": "Number of terms",
                "label_success_add_termin": "Term successfully reserved.",
                "label_success_remove_termin": "Term successfully canceled.",
                "label_remove_termin_title": "Cancel term",
                "label_remove_termin_title_are_you_sure": "Do you want to cancel the term?",
                "label_back_termin": "Return term",
                "label_back_termin_are_you_sure": "Do you want to return the term to the user?",
                "label_my_termini": "My terms",
                "label_scheduled_termini": "Scheduled terms",
                "label_no_scheduled_termini": "No scheduled terms",
                "label_termin_type_title": "Term type",
                "label_reserve_termin": "Reserve term",
                "label_add_user_to_termin": "Add user to term",
                "label_rest_termini": "Remaining terms",
                "label_termin_removed_success": "Term successfully removed",
                "label_termin_add_success": "Term successfully added",
                "label_rest_of_termini": "Remaining terms",
                "label_choose_termini": "Choose terms",
                "label_payment_num_termini": "Number of terms",
                "label_payment_type_termini": "Type of terms",
                "label_payment_error_choose_type": "Choose term type",
                "label_active_payment_tr_numbers": "Paid terms",
                "label_active_payment_type": "Term type",
                "label_add_new_type_termini": "Add new term type",
                "label_open_termini_for": "Open terms for",
                "label_open_termini_success": "Terms successfully opened.",
                "label_termin_history": "Terms history",
                "label_termin_history_is_empty": "Terms history is empty",
                "label_max_people_on_termin": "Number of people on term",
                "label_ci_termin_add": "Add new term",
                "label_ci_termin_name": "Term name",
                "label_ci_termin_minutes": "Term duration in minutes",
                "label_ci_termin_intensity": "Term intensity (0 - 5)",
                "label_ci_termin_success_add": "Term successfully added",
                "label_ci_termin_name_en": "Term name (en)",
                "label_set_termini_number": "Set number of terms",
                "label_approve_are_you_sure": "Are you sure you want to approve the term for:",
                "label_success_approved_termin": "Term successfully approved",
                "label_delete_and_cancel_all_users": "Delete and cancel all terms",
                "label_add_td": "Add new term",
                "label_td_name": "Term name",
                "label_td_name_en": "Term name (en)",
                "label_delete_termin_of_the_day_successfully": "Term successfully deleted",
                "label_delete_termin_of_the_day": "Delete term",
                "label_delete_termin_of_the_day_are_you_sure": "Are you sure you want to delete the term",
                "label_success_added_termin_of_the_day": "Term successfully added",
                "label_choose_exist_termin": "Choose existing term",
                "label_search_termini_definition": "Search terms",
                "label_edit_td": "Edit term",
                "label_success_edited_termin_of_the_day": "Term successfully edited",
                "label_all_wod_termini": "Overview of all terms",
                "label_termin_types": "Types of terms",
                "label_ci_nutrition_add": "Add new item",
                "label_ci_nutrition": "Blog",
                "label_ci_nutrition_name": "Item name",
                "label_ci_nutrition_name_en": "Item name (en)",
                "label_role_trainer": "Professor",
                "label_ci_trainer_add": "Add new trainer",
                "label_ci_trainer_name": "Trainer name",
                "label_ci_trainer_name_en": "Trainer name (en)",
                "label_trainer_name": "Trainer",
                "label_training_type_title": "Term type",
                "label_add_user_to_term": "Add user to term",
                "label_training_types": "Types of terms",
                "label_partners": "Trainer"

            },
            SR: {
                "label_max_people_on_training": 'Broj ljudi na terminu',
                "label_name_for_partner": 'trener',
                "label_current_busy": "Trenutna gužva",
                "label_timed_slots": "Saune",
                "label_trainings": 'Termini',
                "label_ci_training_add": 'Dodaj novu uslugu',
                "label_trainers": 'Trener',
                "t_my_trainings": "Moji termini",
                "label_trainings_report": "Izveštaj termina",
                "label_training_success_reserved": "Termin uspešno rezervisan.",
                "label_show_my_trainings": "Prikaži samo moje termine",
                "label_number_of_trainings": "Broj termina",
                "label_success_add_termin": "Uspešno rezervisan termin.",
                "label_success_remove_termin": "Uspešno otkazan termin.",
                "label_remove_termin_title": "Otkazivanje termina",
                "label_remove_termin_title_are_you_sure": "Da li želite da otkažete termin?",
                "label_back_termin": "Vraćanje termina",
                "label_back_termin_are_you_sure": "Da li želite da vratite termin korisniku?",
                "label_my_termini": "Moji termini",
                "label_scheduled_termini": "Zakazani termini",
                "label_no_scheduled_termini": "Nema zakazanih termina",
                "label_termin_type_title": "Tip termina",
                "label_reserve_termin": "Rezerviši termin",
                "label_add_user_to_termin": "Dodaj korisnika na termin",
                "label_rest_termini": "Ostatak termina",
                "label_termin_removed_success": "Uspešno skinut termin",
                "label_termin_add_success": "Uspešno dodat termin",
                "label_rest_of_termini": "Preostalo termina",
                "label_choose_termini": "Izaberi termine",
                "label_payment_num_termini": "Broj termina",
                "label_payment_type_termini": "Tip termina",
                "label_payment_error_choose_type": "Izaberite tip termina",
                "label_active_payment_tr_numbers": "Uplaćeno termina",
                "label_active_payment_type": "Tip termina",
                "label_add_new_type_termini": "Dodaj novi tip termina",
                "label_open_termini_for": "Otvori termine za",
                "label_open_termini_success": "Termin uspešno otvoreni termini.",
                "label_termin_history": "Istorija termina",
                "label_termin_history_is_empty": "Istorija termina je prazna",
                "label_max_people_on_termin": "Broj ljudi na terminu",
                "label_ci_termin_add": "Dodaj novi termin",
                "label_ci_termin_name": "Ime termina",
                "label_ci_termin_minutes": "Trajanje termina u minutama",
                "label_ci_termin_intensity": "Itezitet termina (0 - 5)",
                "label_ci_termin_success_add": "Uspešno dodat termin",
                "label_ci_termin_name_en": "Ime termina (en)",
                "label_set_termini_number": "Postavi broj termina",
                "label_approve_are_you_sure": "Da li ste sigurni da želite da potvrdite termin za:",
                "label_success_approved_termin": "Uspešno potvrđen termin",
                "label_delete_and_cancel_all_users": "Obriši i otkaži sve termine",
                "label_add_td": "Dodaj novi termin",
                "label_td_name": "Ime termina",
                "label_td_name_en": "Ime termina (en)",
                "label_delete_termin_of_the_day_successfully": "Uspešno obrisan termin",
                "label_delete_termin_of_the_day": "Brisanje termina",
                "label_delete_termin_of_the_day_are_you_sure": "Da li ste sigurni da želite da obrišete termin",
                "label_success_added_termin_of_the_day": "Uspešno dodat termin",
                "label_choose_exist_termin": "Izaberi postojeći termin",
                "label_search_termini_definition": "Pretraži termine",
                "label_edit_td": "Izmeni termin",
                "label_success_edited_termin_of_the_day": "Uspešno izmenjen termin",
                "label_all_wod_termini": "Pregled svih termina",
                "label_termin_types": "Vrste termina",
                "label_ci_nutrition_add": "Dodaj novu stavku",
                "label_ci_nutrition": "Blog",
                "label_ci_nutrition_name": "Ime stavke",
                "label_ci_nutrition_name_en": "Ime stavke (en)",
                "label_role_trainer":"Profesor",
                "label_ci_trainer_add": "Dodaj novog trenera",
                "label_ci_trainer_name": "Ime trenera",
                "label_ci_trainer_name_en": "Ime trenera (en)",
                'label_trainer_name': 'Trener',
                "label_training_type_title": "Tip termina",
                "label_add_user_to_term": "Dodaj korisnika na termin",
                "label_training_types": "Vrste termina",
                "label_partners": "Trener"
            }
        },
        TABS: "HOME,TRAININGS,TIMED_SLOTS,ORDERS,SHOP,ORDR_RESERVATION,CASHBACK_CREDIT,REPORT_TR,EMPLOYED_USR,EMPLOYED_TRM,RPRT_TRAINER,TRN_TYPES,USERS,SCHEDULE,PAYMENTS,MEMBERSHIPS,INVOICES,COMPANIES,DOCUMENTATIONS",
        RIGHT_TABS: "NUMBER_OF_TRAININGS,MY_MEMBER,ACCOUNT",
        IS_ENABLED_BOTTOM_BAR: true,
        HIDDEN_COLUMNS_USER_TABLE: "",
        SHOW_USER_ADDITIONAL_INFO: false,
        SHOW_USER_ADDITIONAL_INFO_LESSON_URL: false,
        ENABLE_GENDER: true,
        TRAINER_SEE_ONLY_OWN_SLOTS: false, //ovo je ako je na termin zalepljen trener prikazi samo te
        MUST_SELECT_TRAINER_WHEN_RESERVE_SLOT_AS_ADMIN: false,
        FILTER_TRAINER_ONLY_SLOT_WITH_OWN_CLIENTS: false, //ovo je prvo pokupim treninge pa vidim kome sve drzi treninge i te slotove prikazem
        ENABLE_REMOTE_OPEN_DOOR: false, //ovo je prvo pokupim treninge pa vidim kome sve drzi treninge i te slotove prikazem
        SHOW_VIEW_FILTER_FOR_TRAININGS: true, //da li imaju mogucnost da menjaju view na treninzima
        SHOW_MEMBERSHIP_FOR_PROGRAMS: true,
        USE_QR_SCANNER_FOCUS: false
    },

    NEXT_LEVEL: {
        NAME: "nextlevel",
        HOME: "/home-page",
        WOD: null,
        TITLE: "Next Level",
        LOGIN_LOGO: '/testgym/testgym_logo.png',
        DEFAULT_TRAINING_TYPES: [],
        SHOW_TRAINING_TYPE_REPORT: true,
        ADD_SLOT_PERMISSION: true,
        SHOW_TOTAL_PRICE_REPORT: true,
        SORT_TRAININGS_BY_TIME: "ASC",
        SHOW_PAYMENT_MONEY_IN_PAYMENT_REPORT: true,
        SHOW_TOTAL_TERMINS: true,
        SHOW_INFINITY_TRAININGS: false,
        SHOW_USER_TRAINING_TYPE_ON_TRAINING: true,
        ADD_KEY_FOR_TRAINING: true,
        SHOW_ADD_TRAINER_ON_SLOT: true,
        SHOW_PACKAGE_MEMBERSHIP: true,
        LISTEN_FIREBASE_QR_SCAN: true,
        CUSTOM_LOCALIZATION: {
            EN: {
                "label_max_people_on_training": 'Number people on training',
                "label_name_for_partner": 'trainer'
            },
            SR: {
                "label_max_people_on_training": 'Broj ljudi na treningu',
                "label_name_for_partner": 'trener'
            }
        },
        USER_TYPES: [],
        TABS: "HOME,TRAININGS,REPORT_TR,RPRT_TRAINER,USR_REPORT,TRN_TYPES,USERS,PAYMENTS,SCHEDULE,MEMBERSHIPS,INVOICES,COMPANIES,DOCUMENTATIONS",
        RIGHT_TABS: "NUMBER_OF_TRAININGS,MY_MEMBER,ACCOUNT",
        IS_ENABLED_BOTTOM_BAR: true,
        HIDDEN_COLUMNS_USER_TABLE: "BIRTHDAY,SHOES_SIZE,NOT_COMING,LOYALTY,PARTNER,EXTERNAL_PAR,BAR_BALANCE",
        SHOW_USER_ADDITIONAL_INFO: true,
        SHOW_USER_ADDITIONAL_INFO_LESSON_URL: false,
        ENABLE_GENDER: true,
        TRAINER_SEE_ONLY_OWN_SLOTS: false, //ovo je ako je na termin zalepljen trener prikazi samo te
        MUST_SELECT_TRAINER_WHEN_RESERVE_SLOT_AS_ADMIN: false,
        FILTER_TRAINER_ONLY_SLOT_WITH_OWN_CLIENTS: true, //ovo je prvo pokupim treninge pa vidim kome sve drzi treninge i te slotove prikazem
        SHOW_VIEW_FILTER_FOR_TRAININGS: true, //da li imaju mogucnost da menjaju view na treninzima,
        USE_QR_SCANNER_FOCUS: false
    },

    ZLATAN_GYM: {
        NAME: "zlatangym",
        HOME: "/home-page",
        WOD: null,
        TITLE: "Zlatan Gym",
        LOGIN_LOGO: '/testgym/testgym_logo.png',
        DEFAULT_TRAINING_TYPES: [],
        SHOW_TRAINING_TYPE_REPORT: true,
        ADD_SLOT_PERMISSION: true,
        SHOW_TOTAL_PRICE_REPORT: true,
        SORT_TRAININGS_BY_TIME: "DESC",
        SHOW_PAYMENT_MONEY_IN_PAYMENT_REPORT: true,
        SHOW_TOTAL_TERMINS: true,
        SHOW_INFINITY_TRAININGS: false,
        SHOW_USER_TRAINING_TYPE_ON_TRAINING: true,
        ADD_KEY_FOR_TRAINING: true,
        SHOW_ADD_TRAINER_ON_SLOT: true,
        SHOW_PACKAGE_MEMBERSHIP: true,
        LISTEN_FIREBASE_QR_SCAN: true,
        CUSTOM_LOCALIZATION: {
            EN: {
                "label_max_people_on_training": 'Number people on training',
                "label_name_for_partner": 'trainer'
            },
            SR: {
                "label_max_people_on_training": 'Broj ljudi na treningu',
                "label_name_for_partner": 'trener'
            }
        },
        USER_TYPES: [],
        TABS: "HOME,TRAININGS,ORDERS,ORDR_RESERVATION,USR_REPORT,SHOP,PERSONAL,CASHBACK_CREDIT,REPORT_TR,EMPLOYED_USR,EMPLOYED_TRM,RPRT_TRAINER,TRN_TYPES,USERS,SCHEDULE,PAYMENTS,PARTNERS,MEMBERSHIPS,INVOICES,COMPANIES,DOCUMENTATIONS",
        RIGHT_TABS: "ACCOUNT",
        IS_ENABLED_BOTTOM_BAR: true,
        HIDDEN_COLUMNS_USER_TABLE: "BIRTHDAY,SHOES_SIZE,NOT_COMING,LOYALTY,PARTNER,EXTERNAL_PAR,BAR_BALANCE",
        SHOW_USER_ADDITIONAL_INFO: true,
        SHOW_USER_ADDITIONAL_INFO_LESSON_URL: false,
        ENABLE_GENDER: true,
        TRAINER_CAN_ADD_NOTIFICATION: true,
        MUST_SELECT_TRAINER_WHEN_RESERVE_SLOT_AS_ADMIN: false,
        SHOW_VIEW_FILTER_FOR_TRAININGS: true, //da li imaju mogucnost da menjaju view na treninzima,
        USE_QR_SCANNER_FOCUS: false,
        ADD_NUMBER_TRAININGS_WITH_NEW_PAYMENT_DEFAULT_VALUE: false
    },

    FREE_FIGHTERS_GYM_MMA: {
        NAME: "ffgmma",
        HOME: "/home-page",
        WOD: null,
        TITLE: "Free Fighters Gym MMA",
        LOGIN_LOGO: '/dzony_gym/dzony_logo.png',
        DEFAULT_TRAINING_TYPES: [],
        SHOW_TRAINING_TYPE_REPORT: true,
        ADD_SLOT_PERMISSION: true,
        SHOW_TOTAL_PRICE_REPORT: true,
        SORT_TRAININGS_BY_TIME: "ASC",
        SHOW_PAYMENT_MONEY_IN_PAYMENT_REPORT: true,
        SHOW_TOTAL_TERMINS: true,
        SHOW_INFINITY_TRAININGS: false,
        SHOW_USER_TRAINING_TYPE_ON_TRAINING: true,
        ADD_KEY_FOR_TRAINING: true,
        SHOW_ADD_TRAINER_ON_SLOT: true,
        SHOW_PACKAGE_MEMBERSHIP: true,
        LISTEN_FIREBASE_QR_SCAN: true,
        CUSTOM_LOCALIZATION: {
            EN: {
                "label_max_people_on_training": 'Number people on training',
                "label_name_for_partner": 'trainer',
                "label_terms":"Schedule",
            },
            SR: {
                "label_max_people_on_training": 'Broj ljudi na treningu',
                "label_name_for_partner": 'trener',
                "label_terms":"Stalni raspored",
            }
        },
        TABS: "HOME,TRAININGS,SHOP,ORDERS,WAREHOUSE,USR_REPORT,EMPLOYED_USR,REPORT_TR,TRN_TYPES,USERS,SCHEDULE,PAYMENTS,PARTNERS,MEMBERSHIPS,INVOICES,COMPANIES,DOCUMENTATIONS",
        RIGHT_TABS: "NUMBER_OF_TRAININGS,MY_MEMBER,ACCOUNT",
        IS_ENABLED_BOTTOM_BAR: true,
        HIDDEN_COLUMNS_USER_TABLE: "BIRTHDAY,SHOES_SIZE,NOT_COMING,LOYALTY,PARTNER,EXTERNAL_PAR,BAR_BALANCE",
        SHOW_USER_ADDITIONAL_INFO: false,
        SHOW_USER_ADDITIONAL_INFO_LESSON_URL: false,
        ENABLE_GENDER: true,
        ENABLE_REMOTE_OPEN_DOOR: false,
        USE_QR_SCANNER_FOCUS: false
    },

    AUTOAPP: {
        NAME: "autoapp",
        HOME: "/home-page",
        WOD: null,
        TITLE: "Auto App",
        LOGIN_LOGO: '/podbaragym/podbaragym_logo.png',
        DEFAULT_TRAINING_TYPES: [],
        SHOW_TRAINING_TYPE_REPORT: true,
        ADD_SLOT_PERMISSION: true,
        SHOW_TOTAL_PRICE_REPORT: true,
        SORT_TRAININGS_BY_TIME: "DESC",
        SHOW_PAYMENT_MONEY_IN_PAYMENT_REPORT: true,
        SHOW_TOTAL_TERMINS: true,
        SHOW_INFINITY_TRAININGS: false,
        SHOW_USER_TRAINING_TYPE_ON_TRAINING: false,
        ADD_KEY_FOR_TRAINING: false,
        SHOW_ADD_TRAINER_ON_SLOT: false,
        SHOW_PACKAGE_MEMBERSHIP: false,
        LISTEN_FIREBASE_QR_SCAN: false,
        CUSTOM_LOCALIZATION: {
            EN: {
                "label_max_people_on_training": 'Number people on training',
                "label_name_for_partner": 'trainer',
                "label_ci_shop": "Cupons",
                "label_shop_category_shop": "Cupons",
                "label_orders_bought": "Purchased coupons",
                "label_orders_used": "Used coupons",
                "label_training_type_title": "Payment type",
                "label_payment_type_trainings": "Payment type",
                "label_payment_error_choose_type": "Select a payment type",
                "label_active_payment_type": "Payment type",
                "label_add_new_type_trainings": "Add new payment type",
                "label_role_trainer": "Employee",
                "label_shoes_size": "Internal code",
                "label_number_of_trainings": "Number of slots",
                "label_payment_num_trainings": "Number of slots",
                "label_set_trainings_number": "Set number of slots",
            },
            SR: {
                "label_max_people_on_training": 'Broj ljudi na treningu',
                "label_name_for_partner": 'trener',
                "label_ci_shop": "Kuponi",
                "label_shop_category_shop": "Kuponi",
                "label_orders_bought": "Kupljeni kuponi",
                "label_orders_used": "Iskorišteni kuponi",
                "label_training_type_title": "Tip uplate",
                "label_payment_type_trainings": "Tip uplate",
                "label_payment_error_choose_type": "Izaberite tip uplate",
                "label_active_payment_type": "Tip uplate",
                "label_add_new_type_trainings": "Dodaj novi tip uplate",
                "label_role_trainer": "Zaposleni",
                "label_shoes_size": "Iterni kod",
                "label_number_of_trainings": "Broj termina",
                "label_payment_num_trainings": "Broj termina",
                "label_set_trainings_number": "Postavi broj termina",

            }
        },
        TABS: "HOME,ORDERS,SHOP,CASHBACK_CREDIT,USR_REPORT,TRN_TYPES,USERS,PAYMENTS,INVOICES,COMPANIES",
        RIGHT_TABS: "ACCOUNT",
        IS_ENABLED_BOTTOM_BAR: false,
        // HIDDEN_COLUMNS_USER_TABLE: "BIRTHDAY,NUMBER_OF_TRAININGS,SHOES_SIZE,NOT_COMING,PAID,EXPIRE,LOYALTY,PARTNER,PAYMENT_TYPE,BUTTON_PAYMENTS,DISABLE_USER_INFO,DEBTOR,MEMBERSHIP,EXTERNAL_PAR"

        HIDDEN_COLUMNS_USER_TABLE: "BIRTHDAY,NUMBER_OF_TRAININGS,PAID,EXPIRE,NOT_COMING,LOYALTY,PARTNER,EXTERNAL_PAR,BAR_BALANCE",
    },

    GROUND_BGD: {
        NAME: "groundbgd",
        HOME: "/home-page",
        WOD: null,
        TITLE: "Ground BGD",
        LOGIN_LOGO: '/testgym/testgym_logo.png',
        DEFAULT_TRAINING_TYPES: [],
        SHOW_TRAINING_TYPE_REPORT: true,
        ADD_SLOT_PERMISSION: true,
        SHOW_TOTAL_PRICE_REPORT: true,
        SORT_TRAININGS_BY_TIME: "DESC",
        SHOW_PAYMENT_MONEY_IN_PAYMENT_REPORT: true,
        SHOW_TOTAL_TERMINS: true,
        SHOW_INFINITY_TRAININGS: false,
        SHOW_USER_TRAINING_TYPE_ON_TRAINING: true,
        ADD_KEY_FOR_TRAINING: true,
        SHOW_ADD_TRAINER_ON_SLOT: true,
        SHOW_PACKAGE_MEMBERSHIP: true,
        LISTEN_FIREBASE_QR_SCAN: true,
        CUSTOM_LOCALIZATION: {
            EN: {
                "label_max_people_on_training": 'Number people on training',
                "label_name_for_partner": 'trainer',
                "label_wod": "WOD",
                "label_company_partners": "Special groups",
                "label_name_of_partner": "Name of group",
                "label_partner_add_title": "Add special group",
                "label_without_company_partners": "No filter",
            },
            SR: {
                "label_max_people_on_training": 'Broj ljudi na treningu',
                "label_name_for_partner": 'trener',
                "label_wod": "Trening dana",
                "label_company_partners": "Specijalni grupe",
                "label_name_of_partner": "Ime grupe",
                "label_partner_add_title": "Dodaj novu grupu",
                "label_without_company_partners": "Bez specijalne grupe",
            }
        },
        USER_TYPES: [],
        TABS: "HOME,TRAININGS,INVENTORY,ORDERS,WOD,BAR_POS,PROFIT,BAR_SALDO_REPORT,USR_REPORT,WAREHOUSE,ORDR_RESERVATION,SHOP,CASHBACK_CREDIT,REPORT_TR,EMPLOYED_USR,EMPLOYED_TRM,RPRT_TRAINER,TRN_TYPES,USERS,SCHEDULE,PAYMENTS,PARTNERS,COMPANY_PARTNERS,MEMBERSHIPS,INVOICES,COMPANIES,DOCUMENTATIONS",
        RIGHT_TABS: "ACCOUNT",
        IS_ENABLED_BOTTOM_BAR: true,
        HIDDEN_COLUMNS_USER_TABLE: "BIRTHDAY,SHOES_SIZE,NOT_COMING,PARTNER",
        SHOW_USER_ADDITIONAL_INFO: true,
        SHOW_USER_ADDITIONAL_INFO_LESSON_URL: false,
        ENABLE_GENDER: true,
        SHOW_WOD_RESULTS: true,
        TRAINER_CAN_ADD_NOTIFICATION: true,
        MUST_SELECT_TRAINER_WHEN_RESERVE_SLOT_AS_ADMIN: false,
        SHOW_VIEW_FILTER_FOR_TRAININGS: true, //da li imaju mogucnost da menjaju view na treninzima,
        USE_QR_SCANNER_FOCUS: false,
        ADD_NUMBER_TRAININGS_WITH_NEW_PAYMENT_FORCE_CONFIG: true,
        ADD_NUMBER_TRAININGS_WITH_NEW_PAYMENT_DEFAULT_VALUE: false,
        SHOW_CURRENT_STATE_IN_CASH_REGISTER: false
    },

    SMART_COACH: {
        NAME: "smartcoach",
        HOME: "/home-page",
        WOD: null,
        TITLE: "Smart coach",
        LOGIN_LOGO: '/testgym/testgym_logo.png',
        DEFAULT_TRAINING_TYPES: [],
        SHOW_TRAINING_TYPE_REPORT: true,
        ADD_SLOT_PERMISSION: true,
        SHOW_TOTAL_PRICE_REPORT: true,
        SORT_TRAININGS_BY_TIME: "DESC",
        SHOW_PAYMENT_MONEY_IN_PAYMENT_REPORT: true,
        SHOW_TOTAL_TERMINS: true,
        SHOW_INFINITY_TRAININGS: false,
        SHOW_USER_TRAINING_TYPE_ON_TRAINING: true,
        ADD_KEY_FOR_TRAINING: true,
        SHOW_ADD_TRAINER_ON_SLOT: true,
        SHOW_PACKAGE_MEMBERSHIP: true,
        LISTEN_FIREBASE_QR_SCAN: true,
        CUSTOM_LOCALIZATION: {
            EN: {
                "label_max_people_on_training": 'Number people on training',
                "label_name_for_partner": 'trainer'
            },
            SR: {
                "label_max_people_on_training": 'Broj ljudi na treningu',
                "label_name_for_partner": 'trener'
            }
        },
        USER_TYPES: [
            {
                id: "USER_TYPE_ONLINE",
                label: 'label_user_type_online'
            }
        ],
        TABS: "HOME,TRAININGS,USR_REPORT,REPORT_TR,PERSONAL,EMPLOYED_USR,EMPLOYED_TRM,RPRT_TRAINER,TRN_TYPES,USERS,SCHEDULE,PAYMENTS,MEMBERSHIPS,INVOICES,COMPANIES,DOCUMENTATIONS",
        RIGHT_TABS: "ACCOUNT",
        IS_ENABLED_BOTTOM_BAR: true,
        HIDDEN_COLUMNS_USER_TABLE: "BIRTHDAY,SHOES_SIZE,NOT_COMING,LOYALTY,PARTNER,EXTERNAL_PAR",
        SHOW_USER_ADDITIONAL_INFO: true,
        SHOW_USER_ADDITIONAL_INFO_LESSON_URL: false,
        ENABLE_GENDER: true,
        TRAINER_CAN_ADD_NOTIFICATION: true,
        MUST_SELECT_TRAINER_WHEN_RESERVE_SLOT_AS_ADMIN: false,
        SHOW_VIEW_FILTER_FOR_TRAININGS: true, //da li imaju mogucnost da menjaju view na treninzima,
        USE_QR_SCANNER_FOCUS: false,
        ADD_NUMBER_TRAININGS_WITH_NEW_PAYMENT_DEFAULT_VALUE: false
    },

    STATUSON: {
        NAME: "statuson",
        HOME: "/home-page",
        WOD: null,
        TITLE: "Status On",
        LOGIN_LOGO: '/testgym/testgym_logo.png',
        DEFAULT_TRAINING_TYPES: [],
        SHOW_TRAINING_TYPE_REPORT: true,
        ADD_SLOT_PERMISSION: true,
        SHOW_TOTAL_PRICE_REPORT: true,
        SORT_TRAININGS_BY_TIME: "ASC",
        SHOW_PAYMENT_MONEY_IN_PAYMENT_REPORT: true,
        SHOW_TOTAL_TERMINS: true,
        SHOW_INFINITY_TRAININGS: false,
        SHOW_USER_TRAINING_TYPE_ON_TRAINING: true,
        ADD_KEY_FOR_TRAINING: true,
        SHOW_ADD_TRAINER_ON_SLOT: true,
        SHOW_PACKAGE_MEMBERSHIP: true,
        LISTEN_FIREBASE_QR_SCAN: true,
        CUSTOM_LOCALIZATION: {
            EN: {
                "label_max_people_on_training": 'Number people on training',
                "label_name_for_partner": 'trainer'
            },
            SR: {
                "label_max_people_on_training": 'Broj ljudi na treningu',
                "label_name_for_partner": 'trener'
            }
        },
        //CAMPAIGN
        TABS: "HOME,PROFIT,USR_REPORT,TRAININGS,PERSONAL,REPORT_TR,RPRT_TRAINER,TRN_TYPES,USERS,SCHEDULE,PAYMENTS,PARTNERS,COMPANY_PARTNERS,MEMBERSHIPS,INVOICES,COMPANIES,DOCUMENTATIONS",
        RIGHT_TABS: "NUMBER_OF_TRAININGS,MY_MEMBER,ACCOUNT",
        IS_ENABLED_BOTTOM_BAR: true,
        HIDDEN_COLUMNS_USER_TABLE:"",
        USER_TYPES: [
            {
                id: "USER_TYPE_ONLINE",
                label: 'label_user_type_online'
            },
            {
                id: "USER_TYPE_TRAINING_CENTER",
                label: 'label_user_type_training_center'
            },
            {
                id: "USER_TYPE_BOTH",
                label: 'label_user_type_both'
            },
            {
                id: "USER_TYPE_PERSONAL",
                label: 'label_user_type_personal'
            },
        ],
        SHOW_USER_ADDITIONAL_INFO: true,
        SHOW_USER_ADDITIONAL_INFO_LESSON_URL: false,
        ENABLE_GENDER: true,
        TRAINER_SEE_ONLY_OWN_SLOTS: false, //ovo je ako je na termin zalepljen trener prikazi samo te
        MUST_SELECT_TRAINER_WHEN_RESERVE_SLOT_AS_ADMIN: false,
        FILTER_TRAINER_ONLY_SLOT_WITH_OWN_CLIENTS: true, //ovo je prvo pokupim treninge pa vidim kome sve drzi treninge i te slotove prikazem
        ENABLE_REMOTE_OPEN_DOOR: true, //da li admin moze da otvori remote
        SHOW_VIEW_FILTER_FOR_TRAININGS: true, //da li imaju mogucnost da menjaju view na treninzima
        SHOW_MEMBERSHIP_FOR_PROGRAMS: true,
        USE_QR_SCANNER_FOCUS: false,
        ENABLE_NEW_DESIGN_OF_PERSONAL_PROGRAMS: true
    },

    REACTIVE: {
        NAME: "reactive",
        HOME: "/home-page",
        WOD: null,
        TITLE: "ReActive",
        LOGIN_LOGO: '/testgym/testgym_logo.png',
        DEFAULT_TRAINING_TYPES: [],
        SHOW_TRAINING_TYPE_REPORT: true,
        ADD_SLOT_PERMISSION: true,
        SHOW_TOTAL_PRICE_REPORT: true,
        SORT_TRAININGS_BY_TIME: "ASC",
        SHOW_PAYMENT_MONEY_IN_PAYMENT_REPORT: true,
        SHOW_TOTAL_TERMINS: true,
        SHOW_INFINITY_TRAININGS: false,
        SHOW_USER_TRAINING_TYPE_ON_TRAINING: true,
        ADD_KEY_FOR_TRAINING: true,
        SHOW_ADD_TRAINER_ON_SLOT: true,
        SHOW_PACKAGE_MEMBERSHIP: true,
        LISTEN_FIREBASE_QR_SCAN: false,
        CUSTOM_LOCALIZATION: {
            EN: {
                "label_max_people_on_training": 'Number people on training',
                "label_name_for_partner": 'trainer'
            },
            SR: {
                "label_max_people_on_training": 'Broj ljudi na treningu',
                "label_name_for_partner": 'trener'
            }
        },
        //CAMPAIGN
        TABS: "HOME,PROFIT,USR_REPORT,TRAININGS,REPORT_TR,RPRT_TRAINER,TRN_TYPES,USERS,SCHEDULE,PAYMENTS,PARTNERS,COMPANY_PARTNERS,MEMBERSHIPS,INVOICES,COMPANIES,DOCUMENTATIONS",
        RIGHT_TABS: "NUMBER_OF_TRAININGS,MY_MEMBER,ACCOUNT",
        IS_ENABLED_BOTTOM_BAR: true,
        HIDDEN_COLUMNS_USER_TABLE:"",
        SHOW_USER_ADDITIONAL_INFO: true,
        SHOW_USER_ADDITIONAL_INFO_LESSON_URL: false,
        ENABLE_GENDER: true,
        TRAINER_SEE_ONLY_OWN_SLOTS: false, //ovo je ako je na termin zalepljen trener prikazi samo te
        MUST_SELECT_TRAINER_WHEN_RESERVE_SLOT_AS_ADMIN: false,
        FILTER_TRAINER_ONLY_SLOT_WITH_OWN_CLIENTS: true, //ovo je prvo pokupim treninge pa vidim kome sve drzi treninge i te slotove prikazem
        ENABLE_REMOTE_OPEN_DOOR: false, //da li admin moze da otvori remote
        SHOW_VIEW_FILTER_FOR_TRAININGS: true, //da li imaju mogucnost da menjaju view na treninzima
        SHOW_MEMBERSHIP_FOR_PROGRAMS: true,
        USE_QR_SCANNER_FOCUS: false,
        ENABLE_NEW_DESIGN_OF_PERSONAL_PROGRAMS: true
    },

    VALHALLA: {
        NAME: "valhalla",
        HOME: "/home-page",
        WOD: null,
        TITLE: "Valhalla",
        LOGIN_LOGO: '/testgym/testgym_logo.png',
        DEFAULT_TRAINING_TYPES: [],
        SHOW_TRAINING_TYPE_REPORT: true,
        ADD_SLOT_PERMISSION: true,
        SHOW_TOTAL_PRICE_REPORT: true,
        SORT_TRAININGS_BY_TIME: "ASC",
        SHOW_PAYMENT_MONEY_IN_PAYMENT_REPORT: true,
        SHOW_TOTAL_TERMINS: true,
        SHOW_INFINITY_TRAININGS: false,
        SHOW_USER_TRAINING_TYPE_ON_TRAINING: true,
        ADD_KEY_FOR_TRAINING: true,
        SHOW_ADD_TRAINER_ON_SLOT: true,
        SHOW_PACKAGE_MEMBERSHIP: true,
        LISTEN_FIREBASE_QR_SCAN: false,
        CUSTOM_LOCALIZATION: {
            EN: {
                "label_max_people_on_training": 'Number people on training',
                "label_name_for_partner": 'trainer'
            },
            SR: {
                "label_max_people_on_training": 'Broj ljudi na treningu',
                "label_name_for_partner": 'trener'
            }
        },
        TABS: "HOME,USR_REPORT,TRAININGS,REPORT_TR,RPRT_TRAINER,TRN_TYPES,USERS,SCHEDULE,PAYMENTS,PARTNERS,WOD,MEMBERSHIPS,INVOICES,COMPANIES,DOCUMENTATIONS",
        RIGHT_TABS: "NUMBER_OF_TRAININGS,MY_MEMBER,ACCOUNT",
        IS_ENABLED_BOTTOM_BAR: true,
        HIDDEN_COLUMNS_USER_TABLE:"",
        SHOW_USER_ADDITIONAL_INFO: true,
        SHOW_USER_ADDITIONAL_INFO_LESSON_URL: false,
        ENABLE_GENDER: true,
        TRAINER_SEE_ONLY_OWN_SLOTS: false, //ovo je ako je na termin zalepljen trener prikazi samo te
        MUST_SELECT_TRAINER_WHEN_RESERVE_SLOT_AS_ADMIN: false,
        FILTER_TRAINER_ONLY_SLOT_WITH_OWN_CLIENTS: true, //ovo je prvo pokupim treninge pa vidim kome sve drzi treninge i te slotove prikazem
        ENABLE_REMOTE_OPEN_DOOR: false, //da li admin moze da otvori remote
        SHOW_VIEW_FILTER_FOR_TRAININGS: true, //da li imaju mogucnost da menjaju view na treninzima
        SHOW_MEMBERSHIP_FOR_PROGRAMS: true,
        USE_QR_SCANNER_FOCUS: false,
        ENABLE_NEW_DESIGN_OF_PERSONAL_PROGRAMS: true
    },
}

export default COMPANIES


// WEBPACK FOOTER //
// ./src/services/ListCompany.js